import { AuditorUpdateForm } from 'components/Pages/Auditors';
import { Scaffold } from 'layouts';
import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const AuditorUpdatePage: React.FC = () => {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();

  const onUpdate = useCallback((): void => {
    navigate('/configuracoes/fiscais');
  }, [navigate]);

  return (
    <Scaffold>
      <AuditorUpdateForm auditorId={id} onUpdate={onUpdate} />
    </Scaffold>
  );
};
